import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Shared/Home.vue";
import Courses from "@/views/Shared/Courses.vue";
import SingleCourse from "@/views/Shared/singleCourse.vue";
import Login from "@/views/Shared/auth/login.vue";
import adminRoutes from "./admin";
import learnerRoutes from "./learner";
import tenantRoutes from "./tenant";
import middlewarePipeline from "./kernel/middlewarePipeline";
import { store } from "../store/store";
import auth from "./middleware/auth";
import canRegister from "./middleware/canRegister";
import redirect from "./middleware/Redirect";

Vue.use(Router);
const baseRoutes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    beforeEnter: (to, from, next) => {
      store.commit("updateLoader", false);
      next();
    },
    meta: {
      middleware: [redirect],
    },
  },
  {
    path: "/courses",
    name: "all-external-courses",
    component: Courses,
    meta: {
      middleware: [redirect],
    },
  },
  {
    path: "/cart",
    name: "external-cart",
    component: () => import("@/views/Shared/cart"),
    meta: {
      middleware: [redirect],
    },
  },
  {
    path: "/wishlist",
    name: "external-wishlist",
    component: () => import("@/views/Shared/wishlist"),
    meta: {
      middleware: [redirect],
    },
  },
  {
    path: "/courses/:id",
    name: "single-external-course",
    component: SingleCourse,
    meta: {
      middleware: [redirect],
    },
  },
  {
    path: "/learner/register",
    name: "register-learners",
    component: () => import("@/views/Shared/auth/register"),
    meta: {
      middleware: [canRegister,redirect],
    },
  },
  {
    path: "/learner/login",
    name: "login-learners",
    component: () => import("@/views/Shared/auth/tenant"),
    meta: {
      middleware: [redirect],
    },
  },
  {
    path: "/auth/forgot-password",
    name: "forgot-password",
    component: () => import("@/views/Shared/auth/forgotPassword"),
    meta: {
      middleware: [redirect],
    },
  },
  {
    path: "/auth/reset-password",
    name: "reset-password",
    component: () => import("@/views/Shared/auth/ResetPassword"),
    meta: {
      middleware: [redirect],
    },
  },
  {
    path: "/auth/login-without-password",
    name: "login-without-password",
    component: () => import("@/views/Shared/auth/loginWithoutPassword"),
    meta: {
      middleware: [redirect],
    },
  },
  {
    path: "/tenant/login",
    name: "login-tenants",
    component: () => import("@/views/Shared/auth/tenant"),
    meta: {
      middleware: [redirect],
    },
  },
  {
    path: "/tny/performance",
    name: "tny-performance",
    component: () => import("@/views/Shared/weekly_performance"),
    meta: {
      middleware: [redirect],
    },
  },


  {
    path: "/admin/login",
    name: "Login",
    component: Login,
    meta: {
      middleware: [redirect],
    },
  },
];

const routes = baseRoutes.concat(adminRoutes, tenantRoutes, learnerRoutes);

const router = new Router({
  routes,
  mode: "history",
  scrollBehavior: function(to) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
});
router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next();
  }

  const middleware = to.meta.middleware;
  const context = {
    to,
    from,
    next,
    router,
    store,
  };

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1),
  });
});

export default router;
